import { render, staticRenderFns } from "./noticeBar.vue?vue&type=template&id=73fe8062&scoped=true"
import script from "./noticeBar.vue?vue&type=script&lang=js"
export * from "./noticeBar.vue?vue&type=script&lang=js"
import style0 from "./noticeBar.vue?vue&type=style&index=0&id=73fe8062&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fe8062",
  null
  
)

export default component.exports